import type { Color } from "utils/constants/colorInfo";

export const quickStyle = {
  backgroundColor: (color: Color, opacity: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 = 10) =>
    `qs-background-color-${color}-${opacity}`,
};
